var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldTranslate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.02 2C3 2 2 3 2 5.02v3.92C2 11 3 12 5.02 11.95h3.92C11 12 12 11 11.95 8.93V5.02C12 3 11 2 8.93 2H5.02zm2.1 7.04a3.7 3.7 0 0 1-2.18.72c-.41 0-.75-.34-.75-.75s.34-.75.75-.75c1.02 0 1.87-.7 2.18-1.66H4.94c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.29c.04-.38.35-.68.74-.68s.7.3.74.68H9a.749.749 0 1 1 0 1.5h-.33c-.09.48-.28.93-.53 1.34.27.2.56.32.87.32.41 0 .75.34.75.75s-.34.75-.75.75c-.68 0-1.34-.26-1.89-.72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 15c0-.41.34-.75.75-.75s.75.34.75.75c0 2.96 2.06 5.44 4.83 6.09l-.27-.45a.751.751 0 1 1 1.29-.77l1.05 1.75c.14.23.14.52.01.75-.14.23-.39.38-.66.38-4.27 0-7.75-3.48-7.75-7.75zM21.248 9c0-2.96-2.06-5.44-4.83-6.09l.27.45a.751.751 0 1 1-1.29.77l-1.05-1.75a.745.745 0 0 1-.01-.75c.14-.23.39-.38.66-.38 4.27 0 7.75 3.48 7.75 7.75 0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.84 16.932A5.08 5.08 0 1 0 22 16.93a5.08 5.08 0 0 0-10.161.002zm6.55 2.07-.17-.34h-2.59l-.17.34c-.13.26-.4.41-.67.41-.11 0-.23-.03-.33-.08a.763.763 0 0 1-.34-1.01l2.14-4.27a.76.76 0 0 1 .67-.41c.28 0 .54.16.67.42l2.14 4.27c.18.37.03.82-.34 1.01-.37.18-.82.04-1.01-.34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.469 17.16-.55-1.09-.54 1.09h1.09z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldTranslate);
export default __webpack_public_path__ + "static/media/vuesax-bold-translate.3a9362e7de3e314712c2cf8c32e77163.svg";
export { ForwardRef as ReactComponent };